import Criterion from "./Criterion";

enum Category {
  PERIODONTAL = "PERIODONTAL",
  DENTITION = "DENTITION",
  ORTHODONTICS = "ORTHODONTICS",
}

const order = [Category.ORTHODONTICS, Category.PERIODONTAL, Category.DENTITION];

export function byOrder(c1: Category, c2: Category) {
  return order.indexOf(c1) - order.indexOf(c2);
}

export const categoryCriteria = {
  [Criterion.PERIODONTAL_ORAL_HYGIENE]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_ORAL_HYGIENE_V2]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_GINGIVAL_CONDITION]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_GINGIVITIS]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_GENERALISED_RECESSION]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_LOCALISED_RECESSION]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_RECESSION]: Category.PERIODONTAL,
  [Criterion.PERIODONTAL_FRENUM]: Category.PERIODONTAL,
  [Criterion.DENTITION_MISSING_PERMANENT_TEETH]: Category.DENTITION,
  [Criterion.DENTITION_MISSING_PERMANENT_TEETH_V2]: Category.DENTITION,
  [Criterion.DENTITION_RETAINED_DECIDUOUS_TEETH]: Category.DENTITION,
  [Criterion.DENTITION_RETAINED_DECIDUOUS_TEETH_V2]: Category.DENTITION,
  [Criterion.DENTITION_PEG_SHAPED_LATERAL_INCISORS]: Category.DENTITION,
  [Criterion.DENTITION_PEG_SHAPED_LATERAL_INCISORS_V2]: Category.DENTITION,
  [Criterion.DENTITION_ABRASION]: Category.DENTITION,
  [Criterion.DENTITION_ANTERIOR_ATTRITION]: Category.DENTITION,
  [Criterion.DENTITION_FRACTURED]: Category.DENTITION,
  [Criterion.DENTITION_WHITENING_NEED]: Category.DENTITION,
  [Criterion.DENTITION_CARIES]: Category.DENTITION,
  [Criterion.OCCLUSION_MOLAR_CLASS]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_CUSPID_CLASS]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_OVERBITE_CLASS]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_OVERBITE_CLASS_V2]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_POSTERIOR_OPEN_BITE_CLASS]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_OVERJET_CLASS]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_OVERJET_CLASS_V2]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_SEGMENTAL_LINGUAL_CROSSBITE_CLASS]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_CROSSBITE_CLASS_V2]: Category.ORTHODONTICS,
  [Criterion.OCCLUSION_TOTAL_BUCAL_CROSSBITE_CLASS]: Category.ORTHODONTICS,
  [Criterion.CROWDING_UPPER_ANTERIOR]: Category.ORTHODONTICS,
  [Criterion.CROWDING_UPPER_POSTERIOR]: Category.ORTHODONTICS,
  [Criterion.CROWDING_LOWER_ANTERIOR]: Category.ORTHODONTICS,
  [Criterion.CROWDING_LOWER_POSTERIOR]: Category.ORTHODONTICS,
  [Criterion.CROWDING_UPPER]: Category.ORTHODONTICS,
  [Criterion.CROWDING_LOWER]: Category.ORTHODONTICS,
  [Criterion.SPACING_UPPER_ANTERIOR]: Category.ORTHODONTICS,
  [Criterion.SPACING_LOWER_ANTERIOR]: Category.ORTHODONTICS,
  [Criterion.DENTITION_CUSPID_TEETH_ROTATION]: Category.ORTHODONTICS,
  [Criterion.DENTITION_INCISOR_TEETH_ROTATION]: Category.ORTHODONTICS,
};

export function getI18NKey(category: Category) {
  switch (category) {
    case Category.ORTHODONTICS:
      return "Criterion.Orthodontics";
    case Category.PERIODONTAL:
      return "Criterion.Periodontal";
    case Category.DENTITION:
      return "Criterion.Dentition";
  }
}

export default Category;
